import { render, staticRenderFns } from "./IntroducitonContent2.vue?vue&type=template&id=64371276&scoped=true"
import script from "./IntroducitonContent2.vue?vue&type=script&lang=js"
export * from "./IntroducitonContent2.vue?vue&type=script&lang=js"
import style0 from "./IntroducitonContent2.vue?vue&type=style&index=0&id=64371276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64371276",
  null
  
)

export default component.exports